import React from "react";
import "./donutChart.css";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement } from "chart.js";
import "./donutChart.css";

Chart.register(ArcElement);

const DonutChart = ({ title, height = "332px" }) => {
  const data = {
    labels: ["Pending Queries", "In Progress", "New Queries"],
    datasets: [
      {
        label: "# of Votes",
        data: [35, 35, 30],
        backgroundColor: ["#045097", "#4C5A9F", "#A2ADE9"],
        borderColor: ["#045097", "#4C5A9F", "#A2ADE9"],
        borderWidth: 1,
      },
    ],
  };
  const options = {
    cutout: "65%",
    responsive: true,
    plugins: {
      tooltip: {
        enabled: true, // <-- this option disables tooltips
      },
      legend: {
        display: false, // Hide the legend
      },
    },
  };

  const balls = [
    {
      label: "Pending Queries",
      value: 35,
      color: "#045097",
    },
    {
      label: "In Progress",
      value: 35,
      color: "#4C5A9F",
    },
    {
      label: "New Queries",
      value: 30,
      color: "#A2ADE9",
    },
  ];

  return (
    <div style={{height}} className="pvxDonut">
      <div className="head">
        <div className="text">{title}</div>
        <img
          src="./images/PvxDashboard/Icons/Dots.svg"
          className="dots"
          alt="Dots"
        />
      </div>
      <div className="chart">
        <Doughnut data={data} options={options} />
      </div>
      <div className="balls">
        {balls.map((ball, index) => (
          <div className="data" key={index}>
            <div
              className="ball"
              style={{ backgroundColor: ball.color }}
            ></div>
            <div className="label">
              <span className="text">{ball.label}</span>
              <span className="value">{ball.value}%</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DonutChart;
